import * as t from 'io-ts';
import { defineModels, ModelType } from 'utils/types/models';
// Represents a customer of Terveystalo, e.g. "Matti Meikäläinen"
const User = {
  customerId: t.string,
  firstName: t.string,
  lastName: t.string,
  occupational: t.boolean,
  age: t.union([t.number, t.null]),
  email: t.union([t.string, t.null]),
  phone: t.union([t.string, t.null]),
};
// Represents a question given by HTA API
const Question = {
  id: t.union([t.number, t.undefined]),
  text: t.union([t.string, t.null, t.undefined]),
  instruction: t.union([t.string, t.null, t.undefined]),
  details: t.union([t.string, t.null, t.undefined]),
  askDurationOfSymptom: t.boolean,
  askMoreInformationAboutSymptom: t.boolean,
};
// Represents an answer sent to HTA API
const Answer = {
  id: t.union([t.number, t.undefined]),
  choice: t.union([t.string, t.undefined]),
  durationOfSymptom: t.union([t.string, t.undefined]),
  moreInformationAboutSymptom: t.union([t.string, t.undefined]),
};
// Response from HTA API for start request
const StartResponse = {
  session: t.union([t.string, t.null, t.undefined]),
  questions: t.union([t.array(t.type(Question)), t.undefined]),
};
// Response from HTA API for keywords request
const KeywordsResponse = {
  keywords: t.array(t.string),
};

const QuestionResponse = {
  session: t.union([t.string, t.null, t.undefined]),
  question: t.union([t.type(Question), t.undefined]),
};

const SymptomItem = {
  title: t.union([t.string, t.null, t.undefined]),
  text: t.union([t.string, t.null, t.undefined]),
};

const ResultResponse = {
  secureMetaData: t.union([t.string, t.undefined]),
  errorMsg: t.union([t.string, t.undefined]),
  patient: t.union([t.string, t.null, t.undefined]),
  reason: t.union([t.string, t.null, t.undefined]),
  symptoms: t.union([t.array(t.type(SymptomItem)), t.undefined]),
};

const EncryptedResultBase64 = {
  aesCipher: t.union([t.string, t.null]),
  aesInitializationVector: t.union([t.string, t.null]),
  aesKeyRsaCipher: t.union([t.string, t.null]),
  aesMode: t.union([t.string, t.null]),
};

const EncryptedResultResponse = {
  encryptedMetaData: t.union([t.type(EncryptedResultBase64), t.undefined]),
  errorMsg: t.union([t.string, t.undefined]),
  patient: t.union([t.string, t.null, t.undefined]),
  reason: t.union([t.string, t.null, t.undefined]),
  symptoms: t.union([t.array(t.type(SymptomItem)), t.undefined]),
};

// Response from HTA API for chat metadata request
const ChatMetaDataResponse = {
  secureMetadata: t.union([t.string, t.null, t.undefined]),
};

// Response from HTA API for encrypted chat data request
const EncryptedMetaDataResponse = {
  encryptedMetadata: t.union([t.type(EncryptedResultBase64), t.undefined]),
};

// Define a category of Models for API data
export const ApiModel = defineModels({
  User,
  Question,
  Answer,
  StartResponse,
  KeywordsResponse,
  ResultResponse,
  ChatMetaDataResponse,
  QuestionResponse,
  SymptomItem,
  EncryptedResultResponse,
  EncryptedMetaDataResponse,
});

// Export the compile-time type with a separate name, so both it and the run-time types can be imported at the same time, where needed
export type ApiModelType = ModelType<typeof ApiModel>;
